import type { FC } from 'react';
import { Suspense, lazy } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { User32 } from '@packages/themes/icons';
import { useDeviceType } from '@packages/shared';
import { useCustomerInformation } from '@packages/utilities';
import { LoginDialogComposed } from '../../../LoginDialog';
import { Slot, type SlotProps } from './Slot';

const title = defineMessage({
  id: 'slot.account.label',
  defaultMessage: 'Mein Konto',
});

// dynamic import to avoid loading the mybuy stuff on initial render
const AccountPopoverContent = lazy(
  () => import(/* webpackChunkName: 'AccountPopoverContent' */ './AccountPopoverContent'),
);

export type AccountSlotProps = Pick<SlotProps, 'sx'>;

/** My account slot */
export const AccountSlot: FC<AccountSlotProps> = ({ sx }) => {
  const { customerInformation } = useCustomerInformation();
  const { formatMessage } = useIntl();
  const { isMobile } = useDeviceType();

  return isMobile ? (
    <Slot
      useRouterLink={false}
      href="/mein-konto/uebersicht"
      icon={<User32 />}
      badgeCount={customerInformation?.newsCount}
      linkAriaLabel={formatMessage(title)}
      sx={sx}
    />
  ) : (
    <LoginDialogComposed>
      {(openLoginDialog) => (
        <Slot
          useRouterLink={false}
          href="/mein-konto/uebersicht"
          icon={<User32 />}
          title={formatMessage(title)}
          badgeCount={customerInformation?.newsCount}
        >
          <Suspense>
            <AccountPopoverContent onLogin={openLoginDialog} />
          </Suspense>
        </Slot>
      )}
    </LoginDialogComposed>
  );
};
